import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { setBillingStatusProcess } from "../../commonSlice";

export const goAwsConsoleThunk = createAsyncThunk(
  "resourceExplorer/getAllProvidersBillingStatus",
  async (accountId: string, { dispatch }) => {
    const { postUsersMeProvidersAwsAccountsByAccountIdCfnChangeSets } =
      cloudChiprApi.endpoints;

    try {
      const response = await dispatch(
        postUsersMeProvidersAwsAccountsByAccountIdCfnChangeSets.initiate(
          {
            accountId,
          },
          {
            fixedCacheKey: "cfn-chang-sets",
          },
        ),
      ).unwrap();
      window.open(response.link, "_blank");
      dispatch(setBillingStatusProcess("aws"));
    } catch (e) {
      // @ts-expect-error//TODO: return to this after adding error type
      const errMessage = e?.data?.message || "Something went wrong";
      enqueueSnackbar(errMessage, {
        variant: "snackbarAlert",
        AlertSnackBarProps: {
          severity: "error",
        },
      });
    }
  },
);
